import React, {createContext, useContext, useRef} from 'react'
import PropTypes from 'prop-types'

const WishlistUtilitiesContext = createContext(null)

export const WishlistUtilitiesProvider = ({children}) => {
    const iconRef = useRef(null)
    const createdWishlist = useRef(false)
    const setCreated = (val) => (createdWishlist.current = val)

    return (
        <WishlistUtilitiesContext.Provider
            value={{icon: iconRef, created: createdWishlist, setCreated}}
        >
            {children}
        </WishlistUtilitiesContext.Provider>
    )
}

export const useWishlistUtilities = () => {
    const context = useContext(WishlistUtilitiesContext)
    if (!context) {
        throw new Error('useWishlistUtilities must be used within a WishlistUtilitiesProvider')
    }
    return context
}

WishlistUtilitiesProvider.propTypes = {
    children: PropTypes.node.isRequired,
}
